import { memo } from "react";

import { Badge, Card, Group, Stack, Text } from "@mantine/core";
import { TbBulb } from "react-icons/tb";

import IdeaTypeChip from "modules/ideas/components/IdeaTypeChip";

import { formatDate } from "modules/core/utils/helpers";
import { ideasPrivateRoutesConstants } from "modules/ideas/routes/private/routesConstants";

import { IdeaType } from "modules/ideas/types/entities";

export type DisplayIdeaProps = {
  id: string;
  project_id: string;
  created_at: string;
  name: string;
  description?: string;
  hypothesis: string;
  type: IdeaType;
};

const DisplayIdea = (props: DisplayIdeaProps) => {
  const { id, project_id, created_at, name, description, hypothesis, type } =
    props;

  return (
    <Card
      withBorder
      component="a"
      href={ideasPrivateRoutesConstants.root.href(project_id) + `&idea=${id}`}
      target="_blank"
      rel="noopener noreferrer"
      shadow="xs"
      radius="lg"
    >
      <Stack gap="xs">
        <Badge
          size="xs"
          color="orange"
          variant="transparent"
          tt="capitalize"
          leftSection={<TbBulb size={12} />}
        >
          Idea
        </Badge>

        <div>
          <Text size="sm" fw={600}>
            {name}
          </Text>

          {hypothesis || description ? (
            <Text size="xs" c="gray.6">
              {hypothesis || description}
            </Text>
          ) : null}
        </div>

        <Group justify="space-between">
          <IdeaTypeChip type={type} />

          <Text size="xs" c="gray.6">
            Created:{" "}
            {formatDate({
              datestring: created_at,
              dateFormat: "dd MMM yyyy"
            })}
          </Text>
        </Group>
      </Stack>
    </Card>
  );
};

export default memo(DisplayIdea);
